var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6839 0.113342H1.91599C0.982966 0.113342 0.234863 0.835885 0.234863 1.71899V12.3101C0.234863 13.1932 0.982966 13.9158 1.91599 13.9158H5.27825L7.79994 16L10.3216 13.9158H13.6839C14.6085 13.9158 15.365 13.1932 15.365 12.3101V1.71899C15.365 0.835885 14.6085 0.113342 13.6839 0.113342Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6839 0.113342H1.91599C0.982966 0.113342 0.234863 0.835885 0.234863 1.71899V12.3101C0.234863 13.1932 0.982966 13.9158 1.91599 13.9158H5.27825L7.79994 16L10.3216 13.9158H13.6839C14.6085 13.9158 15.365 13.1932 15.365 12.3101V1.71899C15.365 0.835885 14.6085 0.113342 13.6839 0.113342ZM8.48769 12.4335H7.11223V11.1367H8.48769V12.4335ZM9.29237 7.35634L9.91133 6.75978C10.3033 6.39017 10.5509 5.87142 10.5509 5.3008C10.5509 3.86776 9.31988 2.70706 7.79999 2.70706C6.2801 2.70706 5.04905 3.86776 5.04905 5.3008H6.42452C6.42452 4.58752 7.04348 4.00393 7.79999 4.00393C8.5565 4.00393 9.17546 4.58752 9.17546 5.3008C9.17546 5.65744 9.02416 5.98166 8.7697 6.21509L7.9169 7.03212C7.42174 7.50548 7.11226 8.15391 7.11226 8.86719V9.19141H8.48772C8.48772 8.21876 8.7972 7.8297 9.29237 7.35634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.a12d83850de149b3341621421e379ed5.svg";
export { ForwardRef as ReactComponent };